import { initEngine, startEngine } from "@/music/Engine"


export function initializeStartButton() {
    const startButton = document.getElementById('start-button') as HTMLButtonElement

    startButton.onclick = (event: MouseEvent) => {
        event.stopPropagation()

        initEngine().then(() => startEngine())
    }
}